import { asyncComponent } from "../../helpers/asyncComponent";

/**
 * Asynchronously loads the EmojiPicker component. We do this async so we don't
 * have to load all of the emoji data before the user needs it. There are a LOT
 * of emojis.
 */
export const EmojiDisplayAsync = asyncComponent({
  module: () => import("./EmojiDisplay"),
  component: (module) => module["EmojiDisplay"],
});
